import { render } from "./ManagementSettings.vue?vue&type=template&id=fce82204"
import script from "./ManagementSettings.vue?vue&type=script&lang=js"
export * from "./ManagementSettings.vue?vue&type=script&lang=js"
script.render = render

export default script